var _GapCursorSelection__$pos;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { Selection } from 'prosemirror-state';
export function isGapCursorSelection(selection) {
    return selection instanceof GapCursorSelection;
}
// @ts-expect-error // TODO: implements toJSON
export class GapCursorSelection extends Selection {
    constructor($pos, params) {
        super($pos, $pos);
        _GapCursorSelection__$pos.set(this, void 0);
        this.selectionName = 'GapCursorSelection';
        __classPrivateFieldSet(this, _GapCursorSelection__$pos, $pos, "f");
        this.meta = params === null || params === void 0 ? void 0 : params.meta;
    }
    get $pos() {
        return __classPrivateFieldGet(this, _GapCursorSelection__$pos, "f");
    }
    get pos() {
        return __classPrivateFieldGet(this, _GapCursorSelection__$pos, "f").pos;
    }
    eq(other) {
        return (isGapCursorSelection(other) &&
            this.pos === other.pos &&
            this.$pos.doc.eq(other.$pos.doc));
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return Selection.near($pos);
    }
}
_GapCursorSelection__$pos = new WeakMap();
